import type { i18n as I18nInstance, Resource } from "i18next";
import i18n from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";
import { EN_LANGUAGE } from "@/shared/i18n/en-language";

interface CreateI18nInstanceOptions {
    language: string;
    /** Pre-loaded resources skip the backend loader entirely (used during hydration). */
    resources?: Resource;
}

export const createI18nInstance = async ({ language, resources }: CreateI18nInstanceOptions): Promise<I18nInstance> => {
    const instance = i18n.createInstance();

    instance.use(initReactI18next);

    if (!resources) {
        instance.use(resourcesToBackend(async (lang: string) => import(`../../../resources/translation.${lang}.json`)));
    }

    await instance.init({
        lng: language,
        fallbackLng: EN_LANGUAGE,
        interpolation: { escapeValue: false },
        ...(resources ? { resources } : {}),
    });

    return instance;
};
